import { Grid, type GridProps } from "@hopper-ui/components";
import type { Ref } from "react";

export interface ToastRegionProps extends Omit<GridProps, "aria-label"> {
    "aria-label": string;
    // TODO: This is not how you add a ref to a functional component. use forwardRef instead.
    ref?: Ref<HTMLDivElement>;
}

function InnerToastRegion(props: ToastRegionProps) {
    const { "aria-label": ariaLabel, children, ...rest } = props;

    return (
        <Grid
            {...rest}
            aria-label={ariaLabel}
            position="fixed"
            top={0}
            left={0}
            right={0}
            padding={{
                base: 0,
                xs: "core_80"
            }}
            justifyContent={{
                base: "stretch",
                xs: "center"
            }}
            gap="core_80"
            zIndex={10001}
            // Removing the pointerEvents breaks the animation.
            pointerEvents="none"
        >
            {children}
        </Grid>
    );
}

export const ToastRegion = (props: ToastRegionProps) => <InnerToastRegion {...props} />;
